<template>
  <v-layout row wrap>
    <v-flex xs12 sm12 md12>
      <v-toolbar class="primary white--text">
        <v-flex xs3>
          <h2 class="headline font-weight-light">Lead Product Report</h2>
        </v-flex>
        <v-spacer></v-spacer>

        <router-link to="/Dashboard">
          <v-btn icon>
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </router-link>
      </v-toolbar>

      <!-- firm and Date filter -->
      <!-- <v-toolbar class="mb" color="white--text" flat>
        <v-layout row> </v-layout>
      </v-toolbar> -->
      <v-layout row wrap>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="getFilteredProducts"
            hide-actions
            class="elevation-1 dashboardHead"
          >
            <template slot="items" slot-scope="props">
              <td>
                <b class="primary--text font-weight-bold">{{
                  props.item["name"]
                }}</b>
              </td>
              <td>
                <b class="red--text font-weight-bold">{{
                  props.item["leadQuantity"] || "-"
                }}</b>
              </td>
            </template>
            <template slot="no-data">No Items</template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  data() {
    return {
      headers: [
        { text: "Products", value: "action" },
        { text: "Quantity", value: "quantity" },
      ],
    };
  },
  created() {
    this.$bindAsArray(
      "leads",
      this.$root.$firebaseRefs.leads
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    ),
      this.$bindAsArray(
        "products",
        this.$root.$firebaseRefs.products
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      );
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear"]),

    getFilteredProducts() {
      let products = this.products.filter(
        (item) => item.brand == this.selectedBrand
      );

      this.leads
        .filter(
          (lead) =>
            lead.brand == this.selectedBrand &&
            lead.status == "PENDING" &&
            lead.isBuyer == true
        )
        .map((item) => {
          item.items.map((leadItem) => {
            if (!leadItem.completed) {
              let index = products.findIndex(
                (r) => r[".key"] == leadItem.productId
              );
              if (index && index > -1) {
                if (products[index].leadQuantity == undefined) {
                  products[index].leadQuantity = 0;
                }
                products[index].leadQuantity += leadItem.quantity;
              }
            }
          });
        });
      return products.filter((p) => !!p['leadQuantity']);
    },
  },
  methods: {},
};
</script>

<style >
.theme--light div.select-firm .v-icon {
  color: white;
}
.theme--light div.select-firm .v-label {
  color: white;
}
.theme--light div.select-firm .v-input__slot:before {
  border-color: white !important;
}
div.select-firm .v-select__selection--comma {
  color: white;
}

.disabledCard {
  background: lightgray;
}

.ist-datepicker .v-icon,
.ist-datepicker .v-label,
.ist-datepicker input {
  color: white !important;
}

.ist-datepicker .v-input__slot:before {
  border-color: white !important;
}

.fl2-table {
  border-radius: 5px;
  font-size: 12px;
  font-weight: normal;
  border: none;
  border-collapse: collapse;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  background-color: white;
}

.fl2-table td,
.fl2-table th {
  text-align: center;
  padding: 8px;
}

.fl2-table td {
  border: 1px solid #000000;
  font-size: 12px;
}

.fl2-table thead th {
  color: #ffffff;
  background: #15155d;
  border: 1px solid white;
}

.fl2-table tr:nth-child(even) {
  background: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/components/Informations/ProductLeadReport/ProductLeadReport.vue